import PropTypes from "prop-types";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Modal from "../../../Common/ModalGeneric";

import { deleteIleggelserForsinketMakulering as deleteIleggelserForsinketMakuleringAction } from "../../../../actions/ileggelseForsinketMakuleringerActions";
import {
  getIleggelse as getIleggelseAction,
  getIleggelseKlager as getIleggelseKlagerAction,
} from "../../../../actions/ileggelserActions";

export default function OpphevForsinketMakuleringContainer({
  reloadHistorikk,
}) {
  const ileggelse = useSelector((state) => state.ileggelse);
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [showSubmitSpinner, setShowSubmitSpinner] = useState(false);

  const deleteIleggelserForsinketMakulering = (id) =>
    dispatch(deleteIleggelserForsinketMakuleringAction(id));
  const getIleggelse = (id) => dispatch(getIleggelseAction(id));
  const getIleggelseKlager = (id) => dispatch(getIleggelseKlagerAction(id));

  const handleApiCall = async (event) => {
    event.preventDefault();
    setShowSubmitSpinner(true);
    deleteIleggelserForsinketMakulering(ileggelse.id)
      .then(() => {
        getIleggelse(ileggelse.id);
        getIleggelseKlager(ileggelse.id);
        reloadHistorikk();
        setOpen(false);
        setShowSubmitSpinner(false);
      })
      .catch(() => {
        setShowSubmitSpinner(false);
      });
  };

  const showForsinketMakulering = () =>
    ileggelse &&
    ileggelse.forsinketMakuleringStatus &&
    ileggelse.forsinketMakuleringStatus.deletePossible;

  if (showForsinketMakulering()) {
    return (
      <span style={{ marginLeft: 20 }}>
        <Modal
          id={ileggelse.id}
          modalTitle={`Opphev forsinket makulering av ileggelse ${ileggelse.ileggelsesnummer}`}
          open={open}
          closeModal={() => setOpen(false)}
          openModal={() => setOpen(true)}
          popUpButtonText="Opphev forsinket makulering"
          isButtonLink
          submit={handleApiCall}
          disabled={false}
          submitButtonText="Opphev forsinket makulering"
          showSubmitSpinner={showSubmitSpinner}
          popUpButtonType="button"
        >
          <React.Fragment>
            <p>
              Vil du oppeheve forsinket makulering av ileggelse{" "}
              {ileggelse.ileggelsesnummer}?
            </p>
          </React.Fragment>
        </Modal>
      </span>
    );
  }
  return <span />;
}

OpphevForsinketMakuleringContainer.propTypes = {
  reloadHistorikk: PropTypes.func.isRequired,
};
